/** Compacta níveis sem separar serviços paralelos nem mover níveis bloqueados. */
export function compactJourneyStepSequences<T extends { sequence: number }>(steps: readonly T[], lockedSequences: readonly number[] = []): T[] {
  const levels = [...new Set(steps.map((step) => step.sequence))].sort((a, b) => a - b)
  const sequences = new Map<number, number>()
  let nextSequence = 0
  for (const level of levels) {
    const sequence = lockedSequences.includes(level) ? level : nextSequence
    sequences.set(level, sequence)
    nextSequence = sequence + 1
  }
  return steps.map((step) => ({ ...step, sequence: sequences.get(step.sequence)! }))
}
